import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ReportObj, StaticUrls } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { Router } from '@angular/router';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class BackOfficeService 
{ 
	list: Array<ReportObj>;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private optionsHeader = new RequestOptions({ headers: this.headers });

  constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) 
	{ }

	getServizi(anno: number, mese: number): Observable<Array<ReportObj>>
	{
		if(this.myCookieService.token)
		{
			if (this.ifTokenExpired()) 
			{
				return this.http.get(StaticUrls._backofficeServizi(mese, anno), this.optionsHeader)
					.map(this.handleData)
					.catch(this.handleError);
			}
		}
  }

	getImmobili(anno: number, mese: number): Observable<Array<ReportObj>>
	{
		if(this.myCookieService.token)
		{
			if (this.ifTokenExpired()) 
			{
				return this.http.get(StaticUrls._backofficeImmobili(mese, anno), this.optionsHeader)
					.map(this.handleData)
					.catch(this.handleError);
			}
		}
  }

	getUtenti(anno: number, mese: number): Observable<Array<ReportObj>>
	{
		if(this.myCookieService.token)
		{
			if (this.ifTokenExpired()) 
			{
				return this.http.get(StaticUrls._backofficeUtenti(mese, anno), this.optionsHeader)
					.map(this.handleData)
					.catch(this.handleError);
			}
		}
  }

	private handleError(error: Response | any) 
	{
		let errMsg: string;

		if (error instanceof Response) 
		{
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} 
		else 
		{
			errMsg = error.message ? error.message : error.toString();
		}
		return Observable.throw(errMsg);
	}

	private handleData(res: Response)
	{
		this.list = res.json();
		return this.list;
	}
  
	private ifTokenExpired() 
	{
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/back-office.service.ts